import React from 'react';


import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import { ModalTitle } from './modal-title';



interface PurchaseConfirmationModalProps {
  onClose: () => void
  isPurchaseRequest?: boolean
  tokens?: number | string | null
  success?: boolean
}

export const PurchaseConfirmationModal = ({
  onClose,
  tokens,
  isPurchaseRequest,
  success,
}: PurchaseConfirmationModalProps) => {
  
  if (isPurchaseRequest) {
    return (
      <Dialog
        open
        onClose={onClose}
        maxWidth="xs"
        fullWidth
      >
        <ModalTitle onClose={onClose}>You have submitted your purchase request!</ModalTitle>
        <DialogContent>
          <p>Your purchase request has been submitted to admin(s) and will have to be approved before it shows in your projects folder.</p>
          <p>If you have any questions or need assistance, feel free to reach out to our support team.</p>
        </DialogContent>
        <>
          <DialogActions sx={{justifyContent: 'flex-end', pb: 3, px: 3}}>
            <Button onClick={onClose}>Close</Button>
          </DialogActions>
        </>
      </Dialog>
  
    )
  
  }

  if (success) {
    return (
      <Dialog
        id="purchase-confirmation-modal-success"
        open
        onClose={onClose}
        maxWidth="xs"
        fullWidth
      >
        <ModalTitle onClose={onClose}>Thank you for your purchase!</ModalTitle>
        <DialogContent>
          <p>Your order has been successfully completed. </p>
          {tokens ?
            <p>A confirmation email with your purchase details has been sent to your inbox.</p>
            :
            <p>A confirmation email with your purchase details has been sent to your inbox. Your purchased data will show in the "Purchased data" menu.</p>
          }
          <p> If you have any questions or need assistance, feel free to reach out to our support team.</p>
        </DialogContent>
        <>
          <DialogActions sx={{justifyContent: 'flex-end', pb: 3, px: 3}}>
            <Button onClick={onClose}>Close</Button>
          </DialogActions>
        </>
      </Dialog>
    )
  }
  return (
    <Dialog
      open
      onClose={onClose}
      maxWidth="xs"
      fullWidth
    >
      <ModalTitle onClose={onClose}>Your purchase has been cancelled!</ModalTitle>
      <DialogContent>
        <p>Your order <strong>has not been processed</strong>. </p>
        <p> If you have any questions or need assistance, feel free to reach out to our support team.</p>
      </DialogContent>
      <>
        <DialogActions sx={{justifyContent: 'flex-end', pb: 3, px: 3}}>
          <Button onClick={onClose}>Close</Button>
        </DialogActions>
      </>
    </Dialog>
  )
}
